import { createAction } from 'redux-act';

const userLoginRequest = createAction('USER_LOGIN_REQUEST', data => data);
const userLoginSuccess = createAction('USER_LOGIN_SUCCESS', data => data);
const userLoginError = createAction('USER_LOGIN_ERROR');

const logoutRequest = createAction('LOGOUT_REQUEST', data => data);
const logoutSuccess = createAction('LOGOUT_SUCCESS', data => data);
const logoutError = createAction('LOGOUT_ERROR');

const resetPasswordRequest = createAction('RESET_PASSWORD_REQUEST', data => data);
const resetPasswordSuccess = createAction('RESET_PASSWORD_SUCCESS', data => data);
const resetPasswordError = createAction('RESET_PASSWORD_ERROR');

const forgotPasswordRequest = createAction('FORGOT_PASSWORD_REQUEST', data => data);
const forgotPasswordSuccess = createAction('FORGOT_PASSWORD_SUCCESS', data => data);
const forgotPasswordError = createAction('FORGOT_PASSWORD_ERROR');

const sendOtpRequest = createAction('SEND_OTP_REQUEST', data => data);
const sendOtpSuccess = createAction('SEND_OTP_SUCCESS', data => data);
const sendOtpError = createAction('SEND_OTP_ERROR');

const verifyOtpRequest = createAction('VERIFY_OTP_REQUEST', data => data);
const verifyOtpSuccess = createAction('VERIFY_OTP_SUCCESS', data => data);
const verifyOtpError = createAction('VERIFY_OTP_ERROR');

const forgotPasswordForAdminRequest = createAction('FORGOT_PASSWORD_FOR_ADMIN_REQUEST', data => data);
const forgotPasswordForAdminSuccess = createAction('FORGOT_PASSWORD_FOR_ADMIN_SUCCESS', data => data);
const forgotPasswordForAdminError = createAction('FORGOT_PASSWORD_FOR_ADMIN_ERROR');

const switchAccountsRequest = createAction('SWITCH_ACCOUNTS_REQUEST', data => data);
const switchAccountsSuccess = createAction('SWITCH_ACCOUNTS_SUCCESS', data => data);
const switchAccountsError = createAction('SWITCH_ACCOUNTS_ERROR');

const completeClientOnboardStep = createAction('ONBOARD_STEP_COMPLETE', data => data);
// clear existing Designation action
const handleClearAuthStore = createAction('HANDLE_CLEAR_AUTH_STORE',data => data);

export default {
    userLoginRequest,
    userLoginSuccess,
    userLoginError,

    logoutRequest,
    logoutSuccess,
    logoutError,

    resetPasswordRequest,
    resetPasswordSuccess,
    resetPasswordError,

    forgotPasswordRequest,
    forgotPasswordSuccess,
    forgotPasswordError,
    
    sendOtpRequest,
    sendOtpSuccess,
    sendOtpError,

    verifyOtpRequest,
    verifyOtpSuccess,
    verifyOtpError,

    forgotPasswordForAdminRequest,
    forgotPasswordForAdminSuccess,
    forgotPasswordForAdminError,
    
    switchAccountsRequest,
    switchAccountsSuccess,
    switchAccountsError,
    
    completeClientOnboardStep,
    handleClearAuthStore,
}